import {
  CREATE_ISSUE_FAILURE,
  CREATE_ISSUE_REQUEST,
  CREATE_ISSUE_SUCCESS,
  FETCH_ISSUE_FAILURE,
  FETCH_ISSUE_REQUEST,
  FETCH_ISSUE_SUCCESS,
  FETCH_TEAMS_FAILURE,
  FETCH_TEAMS_REQUEST,
  FETCH_TEAMS_SUCCESS,
  FETCH_WORKFLOW_STATES_FAILURE,
  FETCH_WORKFLOW_STATES_REQUEST,
  FETCH_WORKFLOW_STATES_SUCCESS,
} from '../types'

const initialState = {
  teams: {
    byId: {},
    ids: [],
    loading: false,
    loaded: false,
  },
  workflowStates: {
    byTeamId: {},
  },
  issues: {
    byId: {},
    loading: false,
    loaded: false,
  },
}

function normalizeById(items = []) {
  return items.reduce((result, item) => {
    if (!item || !item.id) return result
    return {
      ...result,
      [item.id]: item,
    }
  }, {})
}

function reduceTeams(state, teams) {
  return {
    ...state,
    byId: normalizeById(teams),
    ids: teams.map(({ id }) => id).filter(Boolean),
    loading: false,
    loaded: true,
  }
}

function reduceWorkflowStates(state, teamId, workflowStates) {
  return {
    ...state,
    byTeamId: {
      ...state.byTeamId,
      [teamId]: {
        byId: normalizeById(workflowStates),
        ids: workflowStates.map(({ id }) => id).filter(Boolean),
        loading: false,
        loaded: true,
      },
    },
  }
}

function reduceIssue(state, issue) {
  if (!issue || !issue.id) return state
  return {
    ...state,
    byId: {
      ...state.byId,
      [issue.id]: {
        ...state.byId[issue.id],
        ...issue,
        loaded: true,
        loading: false,
      },
    },
    loading: false,
    loaded: true,
  }
}

export default function reduceLinear(state = initialState, action) {
  const { item, type } = action
  switch (type) {
    case FETCH_TEAMS_REQUEST:
      return {
        ...state,
        teams: {
          ...state.teams,
          loading: true,
          loaded: false,
        },
      }
    case FETCH_TEAMS_SUCCESS:
      return {
        ...state,
        teams: reduceTeams(state.teams, item || []),
      }
    case FETCH_TEAMS_FAILURE:
      return {
        ...state,
        teams: {
          ...state.teams,
          loading: false,
          loaded: true,
        },
      }
    case FETCH_WORKFLOW_STATES_REQUEST: {
      const { teamId } = item || {}
      if (!teamId) return state
      return {
        ...state,
        workflowStates: {
          ...state.workflowStates,
          byTeamId: {
            ...state.workflowStates.byTeamId,
            [teamId]: {
              ...(state.workflowStates.byTeamId[teamId] || {}),
              loading: true,
              loaded: false,
            },
          },
        },
      }
    }
    case FETCH_WORKFLOW_STATES_SUCCESS: {
      const { teamId, workflowStates = [] } = item || {}
      if (!teamId) return state
      return {
        ...state,
        workflowStates: reduceWorkflowStates(
          state.workflowStates,
          teamId,
          workflowStates
        ),
      }
    }
    case FETCH_WORKFLOW_STATES_FAILURE: {
      const { teamId } = item || {}
      if (!teamId) return state
      return {
        ...state,
        workflowStates: {
          ...state.workflowStates,
          byTeamId: {
            ...state.workflowStates.byTeamId,
            [teamId]: {
              ...(state.workflowStates.byTeamId[teamId] || {}),
              loading: false,
              loaded: true,
            },
          },
        },
      }
    }
    case FETCH_ISSUE_REQUEST:
    case CREATE_ISSUE_REQUEST:
      return {
        ...state,
        issues: {
          ...state.issues,
          loading: true,
          loaded: false,
        },
      }
    case FETCH_ISSUE_SUCCESS:
    case CREATE_ISSUE_SUCCESS:
      return {
        ...state,
        issues: reduceIssue(state.issues, item),
      }
    case FETCH_ISSUE_FAILURE:
    case CREATE_ISSUE_FAILURE:
      return {
        ...state,
        issues: {
          ...state.issues,
          loading: false,
          loaded: true,
        },
      }
    default:
      return state
  }
}
